var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * Uma linha: uma noite, ou um atleta (B-36).
 *
 * Quando a linha e um atleta, o nome dele abre a ficha - `selectable` diz se ha o que
 * abrir, para a view nao desenhar botao numa data.
 */
let SleepRowScope = class SleepRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.cells = [];
        this.selectable = false;
        /** Abre o detalhe deste atleta, quando a linha e um atleta. */
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepRowScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepRowScope.prototype, "cells", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepRowScope.prototype, "selectable", void 0);
SleepRowScope = __decorate([
    Observable
], SleepRowScope);
export { SleepRowScope };
/**
 * Uma coluna da tabela: um atleta.
 *
 * Virou scope por causa do `onSelect`. Antes era `string[]` - so o nome -, e o
 * `patientId` que o dominio ja calcula era DESCARTADO na fronteira do scope, entao
 * a view nunca tinha como levar a lugar nenhum.
 */
let SleepColumnScope = class SleepColumnScope extends Scope {
    constructor() {
        super(...arguments);
        this.name = '';
        /** Se a coluna e um atleta - na disposicao por atleta, a coluna e uma noite. */
        this.selectable = false;
        /** Abre o detalhe deste atleta. */
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepColumnScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepColumnScope.prototype, "selectable", void 0);
SleepColumnScope = __decorate([
    Observable
], SleepColumnScope);
export { SleepColumnScope };
let SleepTableScope = class SleepTableScope extends Scope {
    constructor() {
        super(...arguments);
        this.title = '';
        this.legend = [];
        /** O que as linhas sao, escrito no canto: "Noite" ou "Atleta". */
        this.corner = 'Noite';
        /** As colunas, na ordem das celulas de cada linha: os atletas, ou as noites. */
        this.columns = [];
        this.rows = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepTableScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], SleepTableScope.prototype, "phase", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepTableScope.prototype, "legend", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepTableScope.prototype, "corner", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepTableScope.prototype, "columns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepTableScope.prototype, "rows", void 0);
SleepTableScope = __decorate([
    Observable
], SleepTableScope);
export { SleepTableScope };
let SleepTabScope = class SleepTabScope extends Scope {
    constructor() {
        super(...arguments);
        this.key = '';
        this.label = '';
        this.active = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepTabScope.prototype, "key", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepTabScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], SleepTabScope.prototype, "phase", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepTabScope.prototype, "active", void 0);
SleepTabScope = __decorate([
    Observable
], SleepTabScope);
export { SleepTabScope };
let SleepOptionScope = class SleepOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.value = '';
        this.label = '';
        this.active = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepOptionScope.prototype, "active", void 0);
SleepOptionScope = __decorate([
    Observable
], SleepOptionScope);
export { SleepOptionScope };
/** Um atleta na lista de escolha, com o estado de marcado. */
let SleepCandidateScope = class SleepCandidateScope extends Scope {
    constructor() {
        super(...arguments);
        this.patientId = 0;
        this.name = '';
        this.checked = false;
        this.onToggle = Scope.SYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepCandidateScope.prototype, "patientId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepCandidateScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepCandidateScope.prototype, "checked", void 0);
SleepCandidateScope = __decorate([
    Observable
], SleepCandidateScope);
export { SleepCandidateScope };
let SleepReportScope = class SleepReportScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        // :: a empresa
        /** Se quem esta logado pode ESCOLHER a empresa. So o administrador. */
        this.companyChooser = false;
        // :: a selecao de atletas
        /** As selecoes salvas de quem esta logado. */
        this.selections = [];
        this.selectionName = '';
        /** Quantos atletas a seleção aberta tem. */
        this.selectionSize = 0;
        /** Se o painel de montar selecao esta aberto. */
        this.picking = false;
        this.search = '';
        this.candidates = [];
        /** Quantos estao marcados agora, no painel de escolha. */
        this.checkedCount = 0;
        this.saving = false;
        // :: as tabelas
        this.tabs = [];
        this.downloading = false;
        this.onSearchChanged = Scope.SYNC_ACTION_STRING;
        this.onSelectAll = Scope.ASYNC_ACTION;
        this.onClearAll = Scope.ASYNC_ACTION;
        this.onTogglePicking = Scope.ASYNC_ACTION;
        this.onSaveSelection = Scope.ASYNC_ACTION_STRING;
        this.onDeleteSelection = Scope.ASYNC_ACTION;
        /** A disposicao da tabela (B-36): `noites` ou `atletas` na linha. */
        this.layout = 'noites';
        /** Gira a tabela - noite na linha ou atleta na linha. */
        this.onToggleLayout = Scope.ASYNC_ACTION;
        this.onDownload = Scope.ASYNC_ACTION;
    }
    /** O mesmo numero, para ler: "1 atleta", "12 atletas". */
    get selectionSizeLabel() {
        return `${this.selectionSize} ${this.selectionSize === 1 ? 'atleta' : 'atletas'}`;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], SleepReportScope.prototype, "message", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "companyChooser", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], SleepReportScope.prototype, "companySelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepReportScope.prototype, "selections", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SleepReportScope.prototype, "selectionId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "selectionName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "selectionSize", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "picking", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "search", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepReportScope.prototype, "candidates", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "checkedCount", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "saving", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], SleepReportScope.prototype, "period", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SleepReportScope.prototype, "tabs", void 0);
__decorate([
    observe(),
    __metadata("design:type", SleepTableScope)
], SleepReportScope.prototype, "table", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SleepReportScope.prototype, "downloading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], SleepReportScope.prototype, "layout", void 0);
SleepReportScope = __decorate([
    Observable
], SleepReportScope);
export { SleepReportScope };
//# sourceMappingURL=sleep-report.scope.js.map